import React from 'react';
import clsx from 'clsx';
import { FormattedMessage } from 'react-intl';
import { Form } from 'semantic-ui-react';
import ValidationSpan from './ValidationSpan';

const FormValidationError = ({
  children,
  error,
  position = 'right',
  htmlFor,
  labelText,
  labelId,
}) => (
  <Form.Field>
    <label htmlFor={htmlFor} className={clsx(error && 'aridhia-is-edit-mode-validation-highlight')}>
      {labelId && (<FormattedMessage id={labelId} />)}
      {labelText}
      <ValidationSpan validationError={error} position={position} />
      {children}
    </label>
  </Form.Field>
);

export default FormValidationError;
